var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lm-qms-watch form-group",class:[
    _vm.alignClass
  ]},[_c('div',{attrs:{"id":"clock"}},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.clock.date))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.clock.time))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }